import { jsx, jsxs } from "react/jsx-runtime";
import { IconButton, Span, Tooltip } from "@pcln/horizon";
const PriceIndicator = ({ price, color })=>/*#__PURE__*/ jsx("div", {
        className: `rounded-full px-3 py-1 mx-1 min-w-[70px] text-center ${color}`,
        "aria-label": `Price range ${price}+`,
        children: /*#__PURE__*/ jsx(Span, {
            textStyle: "body3",
            className: "text-center",
            children: price
        })
    });
const renderDollarSigns = (n)=>Array(n + 2).join('$');
function FooterLeftNode({ lowestPrice = 0 }) {
    const priceRanges = [
        {
            price: `${lowestPrice}+ low`,
            color: 'bg-success-3 text-success-11'
        },
        {
            price: `${lowestPrice + 50}+ avg`,
            color: 'bg-caution-3 text-caution-11'
        },
        {
            price: `${lowestPrice + 100}+ high`,
            color: 'bg-error-3 text-error-11'
        }
    ];
    return /*#__PURE__*/ jsxs("div", {
        className: "flex gap-2 items-center",
        children: [
            /*#__PURE__*/ jsx("div", {
                className: "pt-2",
                children: /*#__PURE__*/ jsx(Tooltip, {
                    align: "start",
                    color: "neutral",
                    emphasis: true,
                    showArrow: true,
                    side: "top",
                    hoverable: true,
                    delay: 0,
                    triggerNode: /*#__PURE__*/ jsx(IconButton, {
                        iconName: "info",
                        size: "2xs",
                        type: "plainSecondary",
                        fillNone: true
                    }),
                    children: /*#__PURE__*/ jsx("span", {
                        children: "Use arrow keys to navigate calendar"
                    })
                })
            }),
            /*#__PURE__*/ jsxs("div", {
                className: "flex gap-1 items-center",
                children: [
                    /*#__PURE__*/ jsx(Span, {
                        textStyle: "body3",
                        className: "text-neutral-10",
                        children: "average prices:"
                    }),
                    priceRanges.map((priceRange, index)=>/*#__PURE__*/ jsx(PriceIndicator, {
                            price: lowestPrice === 1 / 0 || lowestPrice < 1 ? renderDollarSigns(index) : `$${priceRange.price}`,
                            color: priceRange.color
                        }, priceRange.price))
                ]
            })
        ]
    });
}
export { FooterLeftNode as default };
